import React from "react";
import {TextField,Paper,Button,AppBar,
    Toolbar,Typography,IconButton} from '@material-ui/core';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

import MenuIcon from '@material-ui/icons/Menu';
import DBHandler from "./DBHandler";
import ListarRetenciones from './Retenciones/ListarRetenciones'
import Usuarios from './Admin/VistaAdmin'//'./Usuarios/ListarUsuarios'
import PrincipalUsuario from './Retenciones/PrincipalUsuario'

import Logo from './logo usos y color-03.png';

let URLBASE = 'usuarios/';


class Login extends React.Component{

    constructor(props){
        super(props);
        this.db = new DBHandler();
        this.state={
            us:'',
            pas:'',
            onLogin:props.onLogin,
            error:'',
            captcha:'',
        }
        this.enviar_login = this.enviar_login.bind(this)
        this.cargar_usuario = this.cargar_usuario.bind(this)
        this.actualizarDatos = this.actualizarDatos.bind(this)
        this.funcionEnter = this.funcionEnter.bind(this);
    }

    componentDidMount(){
        loadCaptchaEnginge(6);
    }


    enviar_login(){
        if(validateCaptcha(this.state.captcha) === true){
            this.db.enviarPeticion(
                this.cargar_usuario,
                URLBASE + 'login',
                'POST',
                {
                    usuario:this.state.us,
                    pass:this.state.pas
                });
        }
    }

    cargar_usuario(datos){
        if('error' in datos){
            this.setState({error:datos.error})
            return;
        }
        this.state.onLogin(datos['usuario'],datos['admin'],datos['cambio']) //la posicion 1 es el usuario y la 3 es si es admin. 4 es para saber si cambian contra
    }

    funcionEnter(ev){
        if(ev.key==='Enter'){
            if(this.state.us.length > 0 && this.state.pas.length > 0 && validateCaptcha(this.state.captcha) === true){
                this.enviar_login();
                ev.preventDefault();
            }
        }
    }

    actualizarDatos(evento,texto){
        let campo = evento.target.name;
        this.setState({[campo]:texto});

    }

    render(){
        return(
            <div style={{width:'100%',height:'100%',textAlign:'center'}}>   
                    
                    <Paper style={{width:'100vw',height:'100vh'}}>
                        
                        <div style={{marginTop:'20px'}}>
                            <img src={Logo} alt=''
                            style={{height:'300px'}}/>
                            
                        </div>
                        
                        <TextField label='Proveedor' name='us' variant='outlined'
                        style={{marginTop:'10vh'}}
                        onChange={(ev)=>this.setState({us:ev.target.value,error:''})}
                        onKeyPress={this.funcionEnter}/>
                        <br/>
                        <TextField label='Contraseña' name='pas'  variant='outlined'
                        onChange={(ev)=>this.setState({pas:ev.target.value,error:''})} 
                        type='password' style={{marginTop:'10px'}}
                        onKeyPress={this.funcionEnter}/>
                        <br/>
                        {this.state.error.length !== 0 ? <p><Typography variant='body1' color='secondary'>{this.state.error}</Typography></p>:null}
                        <br/>
                        <LoadCanvasTemplate />
                        <br />
                        <TextField label='Captcha' name='cap'  variant='outlined'
                        onChange={(ev)=>this.setState({captcha:ev.target.value,error:''})} 
                        type='password' style={{marginTop:'10px'}}
                        value={this.state.captcha}
                        onKeyPress={this.funcionEnter}/>
                        <br />
                        <Button variant='contained' color='primary'
                        onClick={this.enviar_login} 
                        style={{marginTop:'20px'}}
                        >
                         Ingresar
                        </Button>
                    </Paper>
            </div>
        )
    }


}

class CambioPass extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            pass1:'',
            pass2:'',
            usuario:props.usuario,
            error:'',
        }

        this.onCambioPass = props.onCambioPass;
        this.db = new DBHandler();

    }

    componentWillReceiveProps(props){
        this.setState({usuario:props.usuario});
    }

    cambiarContra(){
        if(this.state.pass1 !== this.state.pass2){
            this.setState({error:'Las contraseñas deben ser iguales'});
            return;
        }
        this.db.enviarPeticion(
            this.onCambioPass,
            URLBASE + 'cambiarContra',
            'POST',
            {
                pass:this.state.pass1,
                usuario:this.state.usuario
            }
            );
    }

    funcionEnter(ev){
        if(ev.key==='Enter'){
            if( (this.state.pass1.length > 0 && this.state.pass2.length > 0) && (this.state.pass1 === this.state.pass2)  ){
                this.cambiarContra.bind(this)();
                ev.preventDefault();
            }
        }
    }

    render(){
        return (<div style={{width:'100%',height:'100%',textAlign:'center'}}>   
                
                    <Paper style={{width:'100vw',height:'100vh'}}>
                        <Typography variant='body1' style={{marginTop:'10vh'}} ><p>Cambio de Contraseña</p></Typography><br/>
                        <TextField label='Contraseña Nueva' name='pass1' 
                        onChange={(ev)=>this.setState({pass1:ev.target.value})}
                        type='password' variant='outlined'
                        onKeyPress={this.funcionEnter}/>
                        <br/>
                        <TextField label='Reingrese la Contraseña Nueva' name='pass2' 
                        onChange={(ev)=>this.setState({pass2:ev.target.value})} 
                        type='password' variant='outlined'
                        onKeyPress={this.funcionEnter}/>
                        <br/>
                        {this.state.error.length !== 0 ?<Typography variant='body1' color='secondary'>{this.state.error}</Typography>:null}
                        <br/>
                        <Button variant='contained' color='primary'
                        onClick={this.cambiarContra.bind(this)} 
                        style={{marginTop:'20px'}}
                        >
                        Ingresar
                        </Button>
                    </Paper>
            </div>)
    }
}


export default class main extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            render:false,
            loged:false,
            usuario:'',
            admin:false,
            cambioPass:false,
            cuit:null,
        }
        this.logueado = this.logueado.bind(this);
    }


    cambioPass(){
        this.setState({
            cambioPass:false
        })
    }


    ver_cookie(datos){
        document.cookie = "auth="+datos["token"] + ";";
        this.setState({render:true});
    }

    logueado(usuario,admin,cambioPass){
        this.setState({
            loged:true,
            render:true,
            usuario:usuario,
            admin:admin === 1 ? true:false,
            cambioPass:cambioPass === 1 ? true:false,
            cuit:usuario,
        });
    }



    render(){

        
        if(this.state.loged === false){
            return(<Login onLogin={this.logueado}/>)
        }
        else if(this.state.cambioPass === true){
            return (<CambioPass onCambioPass={this.cambioPass.bind(this)} usuario={this.state.usuario}/>)
        }
        
        else if(this.state.admin){
            return(<Usuarios usuario={this.state.usuario}/>)
        }
        else{
            return( <PrincipalUsuario cuit={this.state.cuit}/>)
            //return(<ListarRetenciones cuit={this.state.cuit} />)
        }
    }
}

const styles = {
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    menuButton: {
      marginLeft: -12,
      marginRight: 20,
    },
  };
  

class Menu extends React.Component{
    constructor(props){
        super(props);
        this.state={
            abierto:false,
            titulo:props.titulo,
        }

    }

    componentWillReceiveProps(props){
        this.setState({titulo:props.titulo})
    }

    render(){
        return(
            <AppBar position='static'>
                <Toolbar>
                    <IconButton className={styles.menuButton} color='inherit' aria-label='Menu' >
                        <MenuIcon/>
                    </IconButton>
                    <Typography variant='title' className={styles.flex} >
                        {this.state.titulo}
                    </Typography>
                </Toolbar>
            </AppBar>
        )
    }
}


function limpiarCont(){
    let cont = document.getElementById("main");
    let cant = cont.childNodes.length;
    for(let x = 0; x< cant; x++){
        cont.removeChild(cont.childNodes[0]);
    }

}
